import React, { useState } from "react";
import "./CircleMenu.css";

const CircleMenu = () => {
  const [isOpen, setIsOpen] = useState(false);

  // Replace with your actual logo URL
  const logoUrl = "https://via.placeholder.com/100";

  const menuItems = [
    { id: 1, label: "کاریابی", icon: "💼" },
    { id: 2, label: "مسیریاب", icon: "🗺️" },
    { id: 3, label: "حمل و نقل", icon: "🚗" },
    { id: 4, label: "دانشجویی", icon: "🎓" },
    { id: 5, label: "ایپی ایران", icon: "🇮🇷" },
  ];

  const radius = 90;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="container">
      <div className="main-circle" onClick={handleToggle}>
        <span>🇩🇪</span>
        راهنمای مهاجرین
      </div>

      {menuItems.map((item, index) => {
        const angle = (index / menuItems.length) * 2 * Math.PI - Math.PI / 2;
        const style = {
          transform: isOpen
            ? `translate(${Math.cos(angle) * radius}px, ${
                Math.sin(angle) * radius
              }px)`
            : "translate(0, 0)",
          opacity: isOpen ? 1 : 0,
        };

        return (
          <div key={item.id} className="menu-circle" style={style}>
            <span style={{ fontSize: 16 }}>{item.icon}</span>
            {item.label}
          </div>
        );
      })}
    </div>
  );
};

export default CircleMenu;
